// extracted by mini-css-extract-plugin
export default {"victron-advice":"App_victron-advice__lNG9b","signature":"App_signature__wnFA1","version":"App_version__-q4ne"};